export const SET_MENU = 'SET_MENU';
export const MENU_OPEN = 'MENU_OPEN';
export const SHOW_ALERT = 'SHOW_ALERT';
export const CLOSE_ALERT = 'CLOSE_ALERT';
export const SET_MODE = 'SET_MODE';
export const SHOW_CHANGE_PASS_MODAL = 'SHOW_CHANGE_PASS_MODAL';
export const CLOSE_CHANGE_PASS_MODAL = 'CLOSE_CHANGE_PASS_MODAL';
export const LOAD = 'LOAD';
export const UNLOAD = 'UNLOAD';
export const SHOW_OTP_MODAL = 'SHOW_OTP_MODAL';
export const CLOSE_OTP_MODAL = 'CLOSE_OTP_MODAL';
export const SHOW_CONFIRM_MODAL = 'SHOW_CONFIRM_MODAL';
export const CLOSE_CONFIRM_MODAL = 'CLOSE_CONFIRM_MODAL';
export const SHOW_CONFIRM_UPGRADE_CARD_MODAL = 'SHOW_CONFIRM_UPGRADE_CARD_MODAL';
export const GO_TO_NEXT_STEP = 'GO_TO_NEXT_STEP';
export const BACK_TO_PREVIOUS_STEP = 'BACK_TO_PREVIOUS_STEP';
export const BACK_TO_FIRST_STEP = 'BACK_TO_FIRST_STEP';
export const UPDATE_ONBOARDING_DATA = 'UPDATE_ONBOARDING_DATA';
export const SHOW_OTP_MODAL_CARD_OPERATION = 'SHOW_OTP_MODAL_CARD_OPERATION';
export const SHOW_OTP_MODAL_CHANGE_PIN = "SHOW_OTP_MODAL_CHANGE_PIN";
export const SHOW_OTP_MODAL_SET_PIN = "SHOW_OTP_MODAL_SET_PIN";
export const SHOW_OTP_MODAL_INTRABANK_TRANSFER = "SHOW_OTP_MODAL_INTRABANK_TRANSFER";
export const SET_ECOMMERCE_ON = 'SET_ECOMMERCE_ON';
export const SET_ECOMMERCE_OFF = 'SET_ECOMMERCE_OFF';
export const SET_CVV2 = 'SET_CVV2';
export const RESET_CVV2 = 'RESET_CVV2';
export const RESET_ECOM = 'RESET_ECOM';
export const OPEN_LOADING_API = 'OPEN_LOADING_API';
export const CLOSE_LOADING_API = 'CLOSE_LOADING_API';
export const UPDATE_BALANCE = 'UPDATE_BALANCE';
export const SHOW_OTP_MODAL_TRANSFER_247 = "SHOW_OTP_MODAL_TRANSFER_247";
export const SHOW_CONFIRM_ACTIVE_CARD_MODAL = "SHOW_CONFIRM_ACTIVE_CARD_MODAL";
export const SET_ACTIVE_CARD = "SET_ACTIVE_CARD";
export const SHOW_OTP_MODAL_SET_USAGE_LIMTER = 'SHOW_OTP_MODAL_SET_USAGE_LIMTER';



